// app/(auth)/forgot-password/forgot-password-form.tsx
// Forgot Password Form - sends Supabase reset password email

"use client"

import { useState } from "react"
import { useActionState } from "react"
import { useFormStatus } from "react-dom"
import { useRouter } from "next/navigation"
import { requestPasswordReset } from "@/app/actions/auth"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { CardContent } from "@/components/ui/card"
import { Alert, AlertDescription } from "@/components/ui/alert"

type ResetState = {
  error?: string
  success?: boolean
}

function SubmitButton() {
  const { pending } = useFormStatus()

  return (
    <Button type="submit" className="w-full" disabled={pending}>
      {pending ? "Enviando link..." : "Enviar link de redefinição"}
    </Button>
  )
}

export function ForgotPasswordForm() {
  const [state, formAction] = useActionState<ResetState | undefined, FormData>(
    requestPasswordReset,
    undefined
  )
  const [email, setEmail] = useState("")
  const router = useRouter()

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)
  }

  const handleBackToLogin = () => {
    router.push("/login")
  }

  const displayError = state?.error
  const isSuccess = state?.success

  return (
    <form action={formAction}>
      <CardContent className="space-y-4">
        {isSuccess && (
          <Alert className="border-green-500 bg-green-50 [&>svg]:text-green-600">
            <AlertDescription className="text-green-900">
              Se o email estiver cadastrado, você receberá um link para redefinir sua senha em
              alguns minutos.
            </AlertDescription>
          </Alert>
        )}
        {displayError && (
          <Alert variant="destructive">
            <AlertDescription>{displayError}</AlertDescription>
          </Alert>
        )}

        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            name="email"
            type="email"
            placeholder="assessor@exemplo.com"
            required
            value={email}
            onChange={handleEmailChange}
          />
        </div>

        <div className="space-y-3">
          <SubmitButton />
          <button
            type="button"
            onClick={handleBackToLogin}
            className="w-full text-center text-xs font-medium text-gray-600 hover:text-gray-900"
          >
            Voltar para o login
          </button>
        </div>
      </CardContent>
    </form>
  )
}

